import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import { ReactComponent as IconHeart } from '../../icons/Heart.svg'

const ConflictCard = ({
  title,
  topicImage,
  optionLabel,
  selectionLabel,
  onSelect,
}) => {

  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: '8px',
        maxWidth: '400px',
        display: 'inline-grid',
        // alignContent: {
        //   sm: 'center',
        // },
      }}
    >
      <Stack
        display="grid"
        gap={2}
        justifyItems="center"
        justifyContent="center"
        gridTemplateRows="1fr auto"
        py={2}
        px={{
          xs: 1,
          sm: 2,
        }}
        textAlign="center"
      >
        <Stack>
          <Typography
            variant="body1Medium"
            mb={1}
          >
            {topicImage?.fields?.title}
          </Typography>
          <Box
            sx={{
              mx: 'auto',
              width: {
                xs: 45,
                sm: 72,
              },
              height: {
                xs: 45,
                sm: 72,
              },
            }}
          >
            <img 
              src={topicImage?.fields?.file?.url}
              alt={topicImage?.fields?.title}
            />
          </Box>
          {/* <Typography
            variant="labelUpper"
            mb={1}
          >
            {optionLabel}
            {' '}
            {solutionNumber}
          </Typography> */}
          <Typography
            variant="label"
            mb={2}
          >
            {selectionLabel}
          </Typography>
          <Typography
            variant="body1Medium"
          >
            {title}
          </Typography>
        </Stack>
        <Box
          sx={theme => ({
            justifySelf: 'center',
            display: 'inline-grid',
            placeItems: 'center',
            placeContent: 'center',
            width: 64,
            height: 64,
            borderRadius: 32,
            bgcolor: 'primary.lightest',
            transition: theme.transitions.create(['background-color']),
            cursor: 'pointer',
            '&:hover': {
              bgcolor: 'primary.light',
            },
          })}
          onClick={onSelect}
        >
          <IconHeart
            width="32"
            height="32"
          />
        </Box>
      </Stack>
    </Paper>
  )
}

export default ConflictCard